import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { ReplayAnimationDecorator } from "@/__stories__/ReplayAnimationDecorator";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import type { AnimatedSectionProps } from "@/ui/layout/animated/AnimatedSection";
import { AnimatedSection } from "@/ui/layout/animated/AnimatedSection";
import {
  FadeInUpDelay,
  FadeInUpDelayValues,
} from "@/ui/layout/animated/FadeInUpView";
import { ColorToken } from "@/ui/theme/tokens";

const sections = Array.from({ length: 4 }, () => faker.lorem.words(3));

const StoryMeta: Meta<AnimatedSectionProps> = {
  title: "Layout/Animated/Animated Section",
  component: AnimatedSection,
  argTypes: {
    delay: {
      control: "select",
      options: FadeInUpDelayValues,
    },
  },
  args: {
    delay: FadeInUpDelay.Default,
  },
};

type Story = StoryObj<AnimatedSectionProps>;

const Default: Story = {
  render: (args) => {
    return (
      <ReplayAnimationDecorator>
        {/* eslint-disable-next-line max-params -- map callback requires index for delay */}
        {sections.map((label, index) => {
          return (
            <AnimatedSection
              delay={index * (args.delay ?? FadeInUpDelay.Default)}
              key={label}
            >
              <Box
                backgroundColor={ColorToken.Primary10}
                borderRadius={12}
                padding={16}
              >
                <Text testID={`story-${index}`} variant="body">
                  {label} (delay:{" "}
                  {index * (args.delay ?? FadeInUpDelay.Default)}ms)
                </Text>
              </Box>
            </AnimatedSection>
          );
        })}
      </ReplayAnimationDecorator>
    );
  },
};

export { Default };
export default StoryMeta;
